__turbopack_context__.v({
  "button": "KPCGmq_button",
  "container": "KPCGmq_container",
  "input": "KPCGmq_input",
  "loader": "KPCGmq_loader",
});
